(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairHostsController', VirtualFairHostsController)

    VirtualFairHostsController.$inject = ['$uibModal', 'VirtualFairService'];


    function VirtualFairHostsController($uibModal, VirtualFairService) {
        var vm = this;

        vm.queryFlag                    = false;
        vm.expos                        = [];
        vm.expotypes                    = [];
        vm.expoSelected                 = -1;
        vm.selectExpos                  = selectExpos;
        vm.getByFilter                  = getByFilter;
        vm.createExpo                   = createExpo;
        vm.sendEmailTest                = sendEmailTest;
        vm.deleteVirtualFair            = deleteVirtualFair;
        vm.VirtualFairHostsStatus    = VirtualFairHostsStatus;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;
        
        function activate() {
            vm.setPage(1);
            vm.selectExpos();
            vm.getByFilter();
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function selectExpos () {
            VirtualFairService.getAll().then(function(response){
                vm.expos = response.data;
                vm.expos.unshift({id: -1, name: '--- All ---'});
            });
        }

        function getByFilter () {
            vm.queryFlag = false;
            let query = {};
            query['page'] = vm.page;
            query['virtual_fair_id'] = vm.expoSelected;
            VirtualFairService.getVirtualFairsBySettings(query).then(function(response){
                vm.queryFlag = true;
                vm.virtualfairs = response.data.data;
                vm.totalItems = response.data.total;
                vm.itemsPerPage = response.data.per_page;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
            });
        }

        function createExpo(virtualfair = null) {
            $uibModal.open({
                templateUrl: "templates/virtualfairs/settings/form/form.modal.html",
                controller: "VirtualFairHostsFormController",
                controllerAs: "vm",
                resolve: {
                    virtualfair: () => {
                        return virtualfair;
                    },
                    expotypes: () => {
                        return vm.expotypes;
                    }
                },
            });
        }

        function sendEmailTest (virtualfair) {
            alertify.prompt('Email confirmation test', 'Who do you want to send this email to?', null,
                function(evt, value ){
                    if(value && value.length){
                        let data = {
                            id: virtualfair.id,
                            email: value
                        }
                    
                        VirtualFairService.sendEmailTest(data)
                        .then(function (response) {
                            if(!response.data.error) {
                                alertify.success('Email confirmation test sended!');
                            } else {
                                alertify.error(response.data.msg);
                            }
                        });
                    }
                },
                function(){
                    return true;
                });
        }

        function deleteVirtualFair (virtualfair) {
            if(virtualfair.pre_registrations.length == 0) {
                alertify.confirm(
                    'Delete Virtual Fair',
                    `Do you really want to delete this <strong>${virtualfair.name}</strong>?`,
                    function () {
                        VirtualFairService.deleteVirtualFair(virtualfair.id)
                            .then(function (response) {
                                if(!response.data.error) {
                                    vm.setPage(1);
                                    vm.getByFilter();
                                    alertify.success('Virtual event successfull deleted!');
                                } else {
                                    alertify.error(response.data.msg);
                                }
                            });
                    },
                    function () {
                        return true;
                    }
                );
            }
        }

        function VirtualFairHostsStatus (virtualfair) {
            alertify.confirm(
                'Open/Close Virtual Event',
                'Would you like to <strong>' + (virtualfair.show_to_customers == 0 ? 'OPEN' : 'CLOSE') + '</strong> this Virtual Event for registration of exhibitors?',
                function () {
                    VirtualFairService.VirtualFairHostsStatus(virtualfair.id)
                        .then(function (response) {
                            if(!response.data.error) {
                                virtualfair.show_to_customers = response.data.status;
                                alertify.success('Virtual event successfull updated!');
                            } else {
                                alertify.error(response.data.msg);
                            }
                        });
                },
                function () {
                    return true;
                }
            );
        }

        activate();
    }

})();